export const CategoriesInFocus = [
  {
    id: 1,
    src: "https://images-static.nykaa.com/uploads/b12f48bb-aeca-41e9-82fe-790877b62384.jpg?tr=w-1200,cm-pad_resize",
  },
  {
    id: 2,
    src: "https://images-static.nykaa.com/uploads/b6e3595f-34bd-4b39-8873-4900fbce8504.gif?tr=w-1200,cm-pad_resize",
  },
];